import {EventListItem} from 'attendee/Tickets/EventListItem'
import {Ticket} from 'attendee/Tickets/Ticket'
import {attendeeApiClient} from 'attendee/apiClient'
import {useI18n} from 'i18n/I18nContext'
import {FullPageLoader} from 'attendee/theme/FullPageLoader'
import Page from 'attendee/theme/Page'
import React, {useEffect, useMemo, useState} from 'react'

export function Tickets() {
  const {t} = useI18n()
  const {tickets, loading} = useGetTickets()

  if (loading) {
    return <FullPageLoader />
  }

  const tableClass =
    !tickets || tickets?.length === 0
      ? 'attendant__wrapper'
      : 'responsive_table'

  return (
    <Page>
      <section className="event__schedule-area dark_light_class pt-55 pb-150">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xxl-7 col-xl-7 col-lg-6">
              <h2 className="section__title mb-35">
                {t('attendee.ticketsTitleBefore')}{' '}
                <span className="text__highlight">
                  {t('attendee.ticketsTitleHighlight')}
                </span>
              </h2>
            </div>

            <div className={`${tableClass} mb-35`}>
              <table>
                <thead>
                  <tr>
                    <th>{t('tickets.colNumber')}</th>
                    <th>{t('tickets.colPrice')}</th>
                    <th>{t('tickets.colTier')}</th>
                    <th>{t('tickets.colEvent')}</th>
                    <th>{t('tickets.colStatus')}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {(!tickets || tickets?.length === 0) && (
                    <tr>
                      <td colSpan={6}>{t('attendee.ticketsEmpty')}</td>
                    </tr>
                  )}
                  {tickets &&
                    tickets.map((ticket) => <EventListItem ticket={ticket} />)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </Page>
  )
}

function useGetTickets() {
  const apiClient = useMemo(() => attendeeApiClient(), [])

  const [tickets, setTickets] = useState<Ticket[] | null>(null)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiClient.get(`api/tickets`).finally(() => {
          setLoading(false)
        })
        setTickets(response)
      } catch (error: any) {
        // toast.warning(error.message)
      }
    }
    fetchData()
  }, [apiClient])

  return {tickets, loading}
}
